import { Work, WorkOutline } from '@material-ui/icons';
import { observer } from 'mobx-react';
import { useLoanTypeStore } from '../../../hooks/useLoanTypeStore';
import { FORM_MAX_WIDTH } from '../../../utils/constants';
import { EntityInformationForm } from './entityInformationForm';
import { OneToolCard } from './oneToolCard';

export const AddEntityCard = observer(() => {
  const { loanTypeStore } = useLoanTypeStore();
  return (
    <OneToolCard
      maxWidth={FORM_MAX_WIDTH}
      icon={WorkOutline}
      title={'Enter Entity Information'}
    >
      <EntityInformationForm
        entityFormStore={
          loanTypeStore.borrowerEntityInformationStore.borrowerEntityFormStore
        }
      />
    </OneToolCard>
  );
});
